import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=54603b51&scoped=true"
import script from "./FilePicker.vue?vue&type=script&lang=js"
export * from "./FilePicker.vue?vue&type=script&lang=js"
import style0 from "./FilePicker.vue?vue&type=style&index=0&id=54603b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54603b51",
  null
  
)

export default component.exports